import { useContext } from "react";
import { AppContext } from "../AppContext";
import { hasAccess, hasRoles } from "../utils/AccessLevels";

export function useAccess() {
  const { role, isAuthReady } = useContext(AppContext);

  return {
    can: (requiredRole) => {
      if (!isAuthReady) return null;
      return hasAccess(requiredRole, role);
    },
    hasRole: (roles) => {
      if (!isAuthReady) return null;
      console.log(`[HAS_ROLE] isAuthReady: ${isAuthReady} role: ${role} roles: ${roles}`);
      return hasRoles(roles, role);
    },
    role,
    isAuthReady,
  };
}